/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeVoterDB_Voters.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Voter Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Monday, September 30, 2019 - 09:59:53 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      09/30/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const VOTER_LIST_CONTAINER_LOADED = 'VOTER_LIST_CONTAINER_LOADED';
export const VOTER_LIST_CONTAINER_UNLOADED = 'VOTER_LIST_CONTAINER_UNLOADED';
export const VOTER_LIST_TABLE_LOADED = 'VOTER_LIST_TABLE_LOADED';
export const VOTER_LIST_TABLE_UNLOADED = 'VOTER_LIST_TABLE_UNLOADED';

export const VOTER_LIST_CHANGE_GROUP = 'VOTER_LIST_CHANGE_GROUP';
export const VOTER_UPDATE_VALUE = 'VOTER_UPDATE_VALUE';
export const VOTER_SELECT_ROW = 'VOTER_SELECT_ROW';

export const VOTER_ADD = 'VOTER_ADD';
export const VOTER_EDIT = 'VOTER_EDIT';
export const VOTER_DELETE = 'VOTER_DELETE';
export const VOTER_OPEN_WARNING = 'VOTER_OPEN_WARNING';
export const VOTER_CLOSE_WARNING = 'VOTER_CLOSE_WARNING';
export const VOTER_DELETE_DISABLE = 'VOTER_DELETE_DISABLE';
export const VOTER_VIEW_CHILD_ITEMS = 'VOTER_VIEW_CHILD_ITEMS';

export const VOTER_EDIT_CONTAINER_LOADED = 'VOTER_EDIT_CONTAINER_LOADED';
export const VOTER_EDIT_CONTAINER_UNLOADED = 'VOTER_EDIT_CONTAINER_UNLOADED';
export const VOTER_EDIT_FORM_LOADED = 'VOTER_EDIT_FORM_LOADED';
export const VOTER_EDIT_FORM_UNLOADED = 'VOTER_EDIT_FORM_UNLOADED';

export const VOTER_SET_GROUP_SELECT = 'VOTER_SET_GROUP_SELECT';
export const VOTER_EDIT_DATA_LOAD = 'VOTER_EDIT_DATA_LOAD';

export const VOTER_EDIT_CONTAINER_SUBMIT = 'VOTER_EDIT_CONTAINER_SUBMIT';
export const VOTER_EDIT_CONTAINER_CANCEL = 'VOTER_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeVoterDB_Voters.js